// Generated by ReScript, PLEASE EDIT WITH CARE


function LoadingInline(props) {
  return "přemýšlím 🤔";
}

let make = LoadingInline;

export {
  make,
}
/* No side effect */
